import { Injectable } from '@angular/core';
import { DropdownMultiselectItem } from '@bayclubs/drop-down';
import { TranslateService } from '@ngx-translate/core';
import { campsenum } from '../models/enums.generated';
import { camps } from '../models/models.generated';

@Injectable({
    providedIn: 'root',
})
export class FilterDropDownsService {
    constructor(private translate: TranslateService) {}

    public createClubDropDownItemsWithCode(filtersContext: camps.OfficeFiltersContext, preselectedClubs: string[]) {
        const allSelected = !preselectedClubs || preselectedClubs.length === 0;

        return filtersContext.clubs.map((x) => this.createDropdownItem(x.code, x.code, allSelected || preselectedClubs.some((c) => c === x.code), x.name));
    }

    public createClubDropDownItemsWitId(filtersContext: camps.OfficeFiltersContext, preselectedClubs: string[]) {
        const allSelected = !preselectedClubs || preselectedClubs.length === 0;

        return filtersContext.clubs.map((x) => this.createDropdownItem(x.id, x.code, allSelected || preselectedClubs.some((c) => c === x.id), x.name));
    }

    public createCategoriesDropDownItems(filtersContext: camps.OfficeFiltersContext, preselectedCategories: string[]) {
        const allSelected = !preselectedCategories || preselectedCategories.length === 0;

        return filtersContext.categories.map((x) => this.createDropdownItem(x.id, x.name, allSelected || preselectedCategories.some((c) => c === x.id), x.name));
    }

    public createCategoriesDropdownItems(categories: camps.CategoryModel[]) {
        return categories.map((x) => this.createDropdownItem(x.id, x.name, true, x.name, false));
    }

    public createCampTypeDropDownItems(preselectedCampTypes: campsenum.CampType[]) {
        const allSelected = !preselectedCampTypes || preselectedCampTypes.length === 0;

        return Object.keys(campsenum.CampType)
            .filter((e) => {
                return !isNaN(e as any);
            })
            .map((e) => this.createDropdownItem(+e, +e, allSelected || preselectedCampTypes.some((c) => c === +e), this.translateCampTypeEnum(campsenum.CampType[e])));
    }

    private translateCampTypeEnum(type: string): string {
        return this.translate.instant('CampType.' + type);
    }

    private createDropdownItem(id, value, isSelected: boolean = false, displayValue: string = null, isActive: boolean = true): DropdownMultiselectItem {
        return <DropdownMultiselectItem>{
            id: id,
            value: value,
            selected: isSelected,
            displayName: displayValue,
            isActive: isActive,
        };
    }
}
